import * as React from 'react'

import {
  useLocationProjectId,
  useLocationResourceStore,
} from '~/client/src/shared/hooks/useLocationResourceStore'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { locationTypeOptionsOf } from '~/client/src/shared/resources/domain/creatableLocationKinds'
import type { IHierarchyAccessors } from '~/client/src/shared/utils/hierarchyAccessors'

import { locationTypesFrom } from './iconGroups'

/** The active project's Type list, or the seeded one until it is loaded. Call from an observer. */
export function useLocationTypes(): IHierarchyAccessors {
  const options = locationTypeOptionsOf(
    useLocationResourceStore(useLocationProjectId()).schema.properties,
  )
  // Seeded names are translated, so they follow a language switch.
  const language = Localization.state.currentLanguage
  return React.useMemo(() => locationTypesFrom(options), [options, language])
}
